
import { defineComponent } from 'vue'
import { IdfButton, IdfModal } from '@invivodf/ui-kit'

export default defineComponent({
  name: 'DeleteCustomerModal',
  components: { IdfModal, IdfButton },
  props: {
    name: {
      type: String,
      require: true,
    },
  },
  setup(props, { emit }) {
    const onCancel = () => {
      emit('close')
    }

    const onConfirm = () => {
      emit('confirm')
    }

    return { onCancel, onConfirm }
  },
})
